export default __webpack_public_path__ + "static/media/imone-title-en.0825fd0e.webp";